import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Login from "./containers/Login";
import Home from "./containers/Home";
import SmartDevices from "./containers/SmartDevices";
import SmartDevice from "./containers/SmartDevice";
import Configure from "./containers/Configure";
import Messages from "./containers/Messages.js";
import Reports from "./containers/Reports.js";
import SmartOrchestrations from "./containers/SmartOrchestrations";

export default class Routes extends Component {

  constructor(props) {
    super(props);
  
    this.state = {

      isAuthenticated: false, 
      isAuthorised: true,       
      userName: ""
    };
  }
  render() {

  return (
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/smartdevices" render={(routeProps)=><SmartDevices {...routeProps} user={this.props.user} darkmode={this.props.darkmode}/>} />
      <Route path="/smartorchestrations" render={(routeProps)=><SmartOrchestrations {...routeProps} user={this.props.user} darkmode={this.props.darkmode}/>} />
      <Route path="/smartdevice/:smartdeviceid" render={(routeProps)=><SmartDevice {...routeProps} user={this.props.user} darkmode={this.props.darkmode}/>} />
      {/* <Route path="/messages" render={(routeProps)=><Messages {...routeProps} user={this.props.user} darkmode={this.props.darkmode}/>} /> */}
      <Route path="/configure" render={(routeProps)=><Configure {...routeProps} user={this.props.user} darkmode={this.props.darkmode}/>} />
      <Route path="/reports" render={(routeProps)=><Reports {...routeProps} user={this.props.user} darkmode={this.props.darkmode}/>} />
    </Switch>)
  }
}